import React from 'react'
import {Dialog} from '@startlibs/components'

export const EmbeddedSuccessDialog = ({message}) => <Dialog title={message}>
<p>Please close this tab to return to worklist.</p>
</Dialog>